import { createReducer } from '@client/redux/utils';
import { Action, fetchCampaignsSuccess } from './actions';
import { State, ActionTypes } from './types';

export const initialState: State = {
    campaigns: [],
    isLoading: false,
    isError: false
};

const handlers = {
    [ActionTypes.FETCH_CAMPAIGNS.REQUEST]: (state: State) => ({
        ...state,
        isLoading: true,
        isError: false
    }),
    [ActionTypes.FETCH_CAMPAIGNS.ERROR]: (state: State) => ({
        ...state,
        isLoading: false,
        isError: true
    }),
    [ActionTypes.FETCH_CAMPAIGNS.SUCCESS]: (state: State, action: Action) => {
        const { payload: campaigns } = action as ReturnType<typeof fetchCampaignsSuccess>;
        return {
            ...state,
            campaigns,
            isLoading: false,
            isError: false
        };
    }
};

export default createReducer(handlers, initialState);
